import React from 'react';
import { MovieProvider } from './movie/MovieProvider';
import VisualEditor from './components/VisualEditor';
import { AlertProvider } from './components/AlertContext';
import AlertDialog from './components/AlertDialog'; 
import './App.css';

import '@fontsource/lato/300.css';
import '@fontsource/lato/400.css';

// replace console.* for disable log on production
if (process.env.NODE_ENV === 'production') {
  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
}

function App() {

  return (
    <MovieProvider>
      <AlertProvider>
        <VisualEditor/>
        <AlertDialog/>
      </AlertProvider>
    </MovieProvider>
  );
}

export default App;
